var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDineInTurnoverMini = function SvgDineInTurnoverMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF4A4A",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeDasharray: "0,0",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.416 23.253H9.581a.602.602 0 1 1 0-1.205h12.835a.602.602 0 1 1 0 1.205ZM22.472 19.988H9.564C8.72 19.988 8 19.266 8 18.424c0-.881.721-1.564 1.564-1.564h.2a5.99 5.99 0 0 1 1.804-3.968c.923-.881 2.044-1.484 3.288-1.723-.44-.32-.68-.843-.68-1.404A1.853 1.853 0 0 1 16.02 8c1.002 0 1.804.801 1.804 1.765 0 .561-.24 1.043-.681 1.404 1.242.24 2.404.8 3.287 1.723 1.083 1.082 1.724 2.486 1.804 3.968h.201c.881 0 1.564.68 1.564 1.564.035.842-.686 1.564-1.527 1.564ZM9.564 18.063c-.201 0-.36.16-.36.361s.159.36.36.36H22.43c.201 0 .361-.16.361-.36s-.16-.36-.36-.36h-1.364l-.08-1.124c-.08-1.203-.6-2.324-1.443-3.207A4.82 4.82 0 0 0 16.9 12.37l-.881-.16-.922.16a4.82 4.82 0 0 0-2.646 1.363 4.67 4.67 0 0 0-1.443 3.207l-.08 1.123zm6.454-8.858c-.32 0-.6.24-.6.561 0 .16.08.32.2.441l.402.32.36-.28c.121-.122.201-.282.201-.441.038-.32-.243-.601-.563-.601Z"
  })))));
};
export default SvgDineInTurnoverMini;